import { render, staticRenderFns } from "./UserGroupTagGroupCustom.vue?vue&type=template&id=d7ee41ca&scoped=true&"
import script from "./UserGroupTagGroupCustom.vue?vue&type=script&lang=ts&"
export * from "./UserGroupTagGroupCustom.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupTagGroupCustom.vue?vue&type=style&index=0&id=d7ee41ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ee41ca",
  null
  
)

export default component.exports